
/* eslint-disable prefer-template */
export const convertDateToGlobalFormat = (dateString) => {
    if (!dateString || dateString === '') return '';
    const date = new Date(dateString);
    const day = date.getDate();
    // anything above 9 goes into 2 digit categories
    return `${day > 9 ? day : '0' + day}-${date.toLocaleString('en-US', { month: 'short' })}-${date.getFullYear()}`;
};
